import { Check, X, Minus } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { useProduct, eur } from "@/lib/product";

const Mark = ({ v }) => {
  if (v === "ok") return <Check className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" />;
  if (v === "ko") return <X className="w-4 h-4 text-orange-600 shrink-0 mt-0.5" />;
  return <Minus className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" />;
};

export const Comparison = () => {
  const { product } = useProduct();
  const price = product ? `${eur(product.current_price)} TTC` : "—";
  const ROWS = [
    ["Bruit intérieur", ["ko", "Élevé : compresseur dans la pièce"], ["ok", "39 dB(A) en mode silencieux, compresseur dehors"], ["ok", "Très silencieux"]],
    ["Efficacité énergétique", ["ko", "Limitée : gaine d'air chaud et infiltrations"], ["ok", "A++ froid (SEER 6,1) · A+ chaud (SCOP 4,0)"], ["ok", "Très bonne"]],
    ["Installation", ["ok", "Gaine passée par la fenêtre"], ["ok", "~10 min, soi-même, kit fenêtre inclus"], ["ko", "Frigoriste certifié obligatoire"]],
    ["Travaux / perçage", ["ok", "Aucun"], ["ok", "Aucun"], ["ko", "Perçage du mur, unité fixée en façade"]],
    ["Autorisation copropriété", ["ok", "Généralement non"], ["ok", "Pas d'unité fixe en façade"], ["ko", "Souvent requise"]],
    ["Mobilité", ["ok", "Oui"], ["ok", "Oui, sur roulettes"], ["ko", "Non, installation définitive"]],
    ["Prix indicatif", ["mid", "≈ 300 à 700 €"], ["ok", price], ["ko", "≈ 1 500 à 3 000 € pose comprise"]],
  ];

  return (
    <section id="comparatif" data-testid="comparison-table-section" className="section bg-white">
      <div className="container-x">
        <SectionHead eyebrow="Comparatif" title="Monobloc, PortaSplit ou split fixe ?" text="Le PortaSplit réunit le meilleur des deux mondes : le confort d'un split, la simplicité d'un mobile." />
        <div className="mt-12 overflow-x-auto -mx-5 px-5 sm:mx-0 sm:px-0">
          <table data-testid="comparison-table" className="compare-table min-w-[720px] w-full">
            <thead>
              <tr>
                <th className="w-[22%]" />
                <th>Clim mobile classique<span>monobloc</span></th>
                <th data-testid="comparison-portasplit-column" className="is-hero">Midea PortaSplit<span>split mobile</span></th>
                <th>Split fixe<span>installé</span></th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map(([label, ...cells]) => (
                <tr key={label}>
                  <td className="font-semibold text-slate-900">{label}</td>
                  {cells.map(([v, txt], i) => (
                    <td key={i} className={i === 1 ? "is-hero" : ""}>
                      <span className="flex gap-2"><Mark v={v} /><span>{txt}</span></span>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-slate-500 mt-4">Fourchettes de prix et niveaux de performance donnés à titre indicatif ; ils varient selon les modèles et les installateurs.</p>
      </div>
    </section>
  );
};
